import config from '@/data/config';

import { httpV1 as http } from '../api';

export async function simulate({
  rate_id,
  amount,
  document,
}) {
  return http
    .post('/cards/simulation', {
      rate_id,
      amount,
      document,
    })
    .then(({ data }) => data);
}

export async function getCreditCardRates() {
  const params = {
    creditor_id: 1,
  };

  return http
    .get(`/products/${config.PRODUCT_ID_CREDIT_CARD}/rates`, { params })
    .then(({ data }) => data);
}

export async function getCreditCardCreditor() {
  return http
    .get(`/creditors?product_id=${config.PRODUCT_ID_CREDIT_CARD}`);
}

export async function getCreditCardTransactionData(proposalId) {
  return http.get(`/cards/transaction/${proposalId}`);
}

export async function verifyCreditCardByExternalId(externalProposalId) {
  const payload = {
    external_proposal_id: externalProposalId,
  };

  return http.get('/cards/proposal', { params: payload });
}

export async function approve(data) {
  return http.post('/cards/credit-operation', data);
}

export async function transactions(proposal_id) {
  return http.get(`/cards/transactions/${proposal_id}`);
}

export async function reverse(data) {
  return http.post('/cards/reverse-transaction', { ...data });
}
